import Image from '@tiptap/extension-image'
import { mergeAttributes } from '@tiptap/core'

export const KnowledgeBaseImage = Image.extend({
  addAttributes() {
    const parent = this.parent ? this.parent() : {}
    return {
      ...parent,
      width: {
        default: null,
        parseHTML: (element: HTMLElement) => element.style.width || null,
        renderHTML: () => ({}),
      },
      align: {
        default: null,
        parseHTML: (element: HTMLElement) => {
          const left = element.style.marginLeft
          const right = element.style.marginRight
          if (left === 'auto' && right === 'auto') return 'center'
          if (left === 'auto') return 'right'
          if (right === 'auto') return 'left'
          return null
        },
        renderHTML: () => ({}),
      },
    }
  },
  renderHTML({ HTMLAttributes, node }) {
    const styles: string[] = []
    if (node.attrs.width) styles.push(`width: ${node.attrs.width}`)
    if (node.attrs.align === 'center') styles.push('display: block', 'margin-left: auto', 'margin-right: auto')
    else if (node.attrs.align === 'left') styles.push('display: block', 'margin-right: auto')
    else if (node.attrs.align === 'right') styles.push('display: block', 'margin-left: auto')

    const attributes = mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)
    if (styles.length) attributes.style = [attributes.style, styles.join('; ')].filter(Boolean).join('; ')

    return ['img', attributes]
  },
})
